<cjm-button
	classes="{{ buttonClasses.LinkNoDecoration }} c-primary-button--loading"
	type="button"
	[title]="
		(active
			? i18nKeys.SharedAssociations.PrimaryButton.Remove.Title
			: i18nKeys.SharedAssociations.PrimaryButton.Set.Title
		) | translate
	"
	[isDisabled]="isDisabled"
	(click)="active ? removeAsPrimary.emit(id) : setAsPrimary.emit(id)"
>
	<!-- Denis: $any is used because typescript can't match 'fa-solid' | 'fa-regular' to `${IconType}` in the template -->
	@if (isLoading) {
		<fa-icon class="c-primary-button__loading" classes="fa-spin" icon="fa-spinner" iconType="fa-solid" />
	} @else {
		@if (type === 'star') {
			<fa-icon
				class="c-primary-button__star"
				icon="fa-star"
				[iconType]="$any(active ? 'fa-solid' : 'fa-regular')"
			/>
		}
		@if (type === 'heart') {
			<fa-icon
				class="c-primary-button__heart"
				icon="fa-heart"
				[iconType]="$any(active ? 'fa-solid' : 'fa-regular')"
			/>
		}
	}

	@if (!iconOnly) {
		{{
			(active
				? i18nKeys.SharedAssociations.PrimaryButton.Remove.Text
				: i18nKeys.SharedAssociations.PrimaryButton.Set.Text
			) | translate
		}}
	} @else {
		<span class="cdk-visually-hidden">
			{{
				(active
					? i18nKeys.SharedAssociations.PrimaryButton.Remove.Text
					: i18nKeys.SharedAssociations.PrimaryButton.Set.Text
				) | translate
			}}
		</span>
	}
</cjm-button>
